module.exports = __webpack_public_path__ + "static/media/prototype.232cffab.jpg";